import React from 'react';
import {setMultiState, toggleType, clearPerson} from '../../api/offers/actions'
import { getQuestionnaires } from '../../api/questionnaires/actions'
import ViewContracts from '../view-contracts'
import AddPhotoId from '../add-photoid'
import { Spinner } from '../../utils';
import AdminFunctions from '../admin-functions'
import AddPercentage from '../add-percentage'

import { isUserAdmin } from '../../api/brokers/actions';


const getContractByType = (contracts, contractType) => {
    if(contracts.hasOwnProperty(contractType)) {
        return contracts[contractType][0]
    }
    else {
        return null
    }
}


class ContractsOverview extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            displayIdView: false,
            displayAdminView: false,
            displayPercentageView: false,
        }

        this.toggleIdView = this.toggleIdView.bind(this)
        this.togglePercentageView = this.togglePercentageView.bind(this)
        this.toggleAdminView = this.toggleAdminView.bind(this)

        this.allTogglesOff = this.allTogglesOff.bind(this)
    }

	componentDidMount() {
		this.props.dispatch(getQuestionnaires());
	}
	
    toggleIdView(){
        this.setState({
            displayIdView: !this.state.displayIdView
        })
    }

    toggleAdminView(){
        this.setState({
            displayAdminView: !this.state.displayAdminView
        })

    }

    togglePercentageView(){
        this.setState({
            displayPercentageView: !this.state.displayPercentageView
        })

    }

    allTogglesOff(){
      return !this.state.displayIdView && !this.state.displayAdminView && !this.state.displayPercentageView
    }

    render() {
        let customers = this.props.customers;

        return (
            
            <div className="container xs-pt-50 xs-pb-50">
                { customers && customers.customerList.length > 0 &&
                    <>
                    <div className="row">
                        <div className="col-12 text-center contracts-overview-title">
                            { this.allTogglesOff() && <h3>Yfirlit trygginga { this.props.customers.isFetching && <Spinner />}</h3> }
                            { this.allTogglesOff() && <p>Hakaðu við þær vörur sem þú vilt reikna út</p>}
                            {this.state.displayIdView && <button className="toggled" onClick={this.toggleIdView.bind(this)}>Bæta við skilríkjum</button>}
                            {!this.state.displayPercentageView && <button onClick={this.togglePercentageView.bind(this)}>Bæta við uppsögn/prósentubr.</button>}
                            {this.state.displayPercentageView && <button className="toggled" onClick={this.togglePercentageView.bind(this)}>Bæta við uppsögn/prósentubr.</button>}
                            {  this.props.admins.data && 
                                <>
                                {!this.state.displayAdminView && <button onClick={this.toggleAdminView.bind(this)}>Bæta við greiðslukorti</button>}
                                {this.state.displayAdminView && <button className="toggled" onClick={this.toggleAdminView.bind(this)}>Bæta við greiðslukorti</button>}
                                </>
                            }
                        </div>
                    </div>
                    { this.allTogglesOff() && <ViewContracts dispatch={this.props.dispatch} customers={this.props.customers} offers={this.props.offers} contracts={this.props.contracts} />}
                    { this.state.displayAdminView && <AdminFunctions /> }
                    { this.state.displayPercentageView && <AddPercentage dispatch={this.props.dispatch} customers={this.props.customers} offers={this.props.offers} contracts={this.props.contracts}/> }
                </>
                }
            </div>
        )
    }
}

ContractsOverview.defaultProps = {
}

export default ContractsOverview;